import React from 'react'
import Footer from '../footer'
import Header from '../header'

export default function Datascience() {
  return (
    <div>
        <Header/>
   <main>
  <style dangerouslySetInnerHTML={{__html: "\n.txtwidth\n{\n\twidth:50%;\n}\n@media screen and (min-width: 680px) {\n  .txtwidth {\n    width:100%;\n  }\n}\n.service-sidebar-area .service-card {\n    margin-bottom: 30px;\n    background-color: #ffffff;\n    -webkit-box-shadow: 0 0 20px 3px rgb(0 0 0 / 5%);\n    box-shadow: 0 0 20px 3px rgb(0 0 0 / 5%);\n}\n.service-sidebar-area .service-details-title {\n    background-color: #2c79ff;\n    color: #ffffff;\n    padding: 15px 20px;\n    margin-bottom: 0;\n}\nul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.service-sidebar-area .service-list ul li {\n    border-bottom: 1px dashed #eeeeee;\n    padding: 15px 20px;\n    font-weight: 500;\n    \n    transition: all 0.5s;\n}\n.service-sidebar-area .service-list ul li i {\n    float: right;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    background-color: #2c79ff;\n    border-radius: 50%;\n    color: #ffffff;\n    font-size: 20px;\n    text-align: center;\n    transition: all 0.5s;\n    position: relative;\n    top: -3px;\n}\n.bx {\n    font-family: boxicons!important;\n    font-weight: 400;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    display: inline-block;\n    text-transform: none;\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n}\n\n\t/* Custom style */\n    .accordion-button::after {\n      background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n      transform: scale(.7) !important;\n    }\n    .accordion-button:not(.collapsed)::after {\n      background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n    }\n" }} />
  <div className="breadcrumb__area include-bg pt-200 pb-150" style={{paddingTop: 50, paddingBottom: 50, backgroundImage:"url(assets/img/breadcrumb/computer1.jpg)"}} data-background="assets/img/breadcrumb/computer1.jpg">
    <div className="container">
      <div className="row">
        <div className="txtwidth" style={{fontSize: 27, fontWeight: 800, color: 'white', paddingBottom: 33, textDecoration: 'underline'}}>Data Science Training</div>
        <div style={{fontSize: 18, color: 'white', paddingBottom: 33}}>Data science and AI technologies are being used for popular services like customer service chatbots at Bank of America, easy-to-search images on Facebook, and even automated fashion tips for clothing buyers of Amazon.
        </div>
      </div>
      <div className="tp-form__btn" style={{paddingBottom: 33}}>
       <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2">
  {/* Button trigger modal */}
  <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
    Book A Demo <i className="fa-regular fa-arrow-right" />
  </button>
  {/* Modal */}
  <div className="modal fade" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
        <p style={{color: '#000f2f', fontSize: 20, textAlign: 'center', textDecoration: 'underline', fontWeight: 700}}>Courses Enquiry</p>
     
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          
        </div>
        <div className="heading_s1 mb-3" style={{textAlign: 'center'}}>
                      <h6>Please feel the below form, we will call you very shortly</h6>
                    </div>
        <div className="modal-body">
        <form action="mail.php" method="POST" className="pt-md-2">
                      <div className="row">
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Your Name *" id="nameEnquiry" className="form-control alpha-only" name="fname" type="text" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Mobile No. *" id="phoneEnquiry" className="form-control number-only" name="mobile" type="text" maxLength={10} oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Email ID" id="emailEnquiry" className="form-control" name="email" type="text" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Course Name" id="course" className="form-control" name="course" type="text" />
                          {/*<input t placeholder="Enter course" id="message" class="form-control" name="Message" rows="4"></textarea>*/}
                        </div>
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                          {/*<input type="submit" name="submit" value="Send Details" class="tp-btn"  id="submitEnquiry" />*/}
                          <button className="tp-btn" onclick="return validationEnquiry();" style={{cursor: 'pointer'}}>
                            <span>Submit <i className="fa-regular fa-arrow-right" /> </span>
                          </button> 
                        </div>
                        <div className="col-sm-12">
                          <div id="alert-msg" className="alert-msg text-center" />
                        </div>
                      </div>
                    </form>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>
</div>
      
      </div>      <div style={{color: '#ffffff', fontSize: 20, fontWeight: 900}}><span>Call Trainer</span><br /><a style={{color:"white"}} href="tel:+91 8976758080"><i className="fa-regular fa-phone" />
          +91 8976758080</a></div>
    </div>
  </div>
  <div className="tp-about__section" style={{paddingTop: 50, paddingBottom: 30}}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div style={{background: '#f3f1ee', padding: 29}}>
            <p style={{borderBottom: '2px solid red', fontSize: 30, fontWeight: 700, paddingBottom: 25}}>Data Science Training</p>
          </div>
         
          <div className="accordion" id="myAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne" style={{fontWeight: 800, fontSize: 18}}>Data Science</button>									
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#myAccordion">
                <div className="card-body">
                <b>SQL</b>
<li>SQL - INTRODUCTION TO SQL</li>
<li>HOW DOES RDBMS WORK?</li>
<li>SQL PROCEDURES</li>
<li>SPECIFYING COLUMNS</li>
<li>SPECIFYING ROWS</li>
<li>PRESENTING DATA</li>
<li>SUMMARIZING DATA</li>
<li>WRITING JOIN QUERIES USING SQL</li>
<li>WORKING WITH SUBQUERIES</li>
<li>INDEXES AND VIEWS</li>
<li>SET OPERATORS</li>
<li>CREATING TABLES & VIEWS USING PROC SQL</li>
<b>STATISTICS ESSENTAIL WITH DATA SCEINCE</b>
<li>SAMPLE OR POPULATION DATA ,</li>
<li>THE FUNDAMENTALS OF DESCRIPTIVE</li>
<li>STATISTICS ,</li>
<li>MEASURES OF CENTRAL TENDENCY,</li>
<li>ASYMMETRY, AND VARIABILITY</li>
<li>PRACTICAL EXAMPLE: DESCRIPTIVE STATISTICS</li>
<li>DISTRIBUTIONS ESTIMATORS AND ESTIMATES</li>
<li>CONFIDENCE INTERVALS: ADVANCED TOPICS</li>
<li>PRACTICAL EXAMPLE: INFERENTIAL STATISTICS</li>
<li>INDEXES AND VIEWS</li>
<li>SET OPERATORS</li>
<li>CREATING TABLES & VIEWS USING PROC SQL</li>
<b>HYPOTHESIS TESTING</b>
<li>INTRODUCTION HYPOTHESIS TESTING:</li>
<li>LET’S START TESTING! ,</li>
<li>PRACTICAL EXAMPLE: HYPOTHESIS TESTING,</li>
<li>THE FUNDAMENTALS OF REGRESSION ANALYSIS</li>
<li>SUBTLETIES OF REGRESSION ANALYSIS ,</li>
<li>ASSUMPTIONS FOR LINEAR REGRESSION ANALYSIS,</li>
<li>DEALING WITH CATEGORICAL DATA</li>
<li>PRACTICAL EXAMPLE: REGRESSION ANALYSIS</li>
<b>R PROGRAMMING</b>
<li>R BASICS,</li>
<li>DATA STRUCTURES IN R,</li>
<li>R PROGRAMMING FUNDAMENTALS ,</li>
<li>WORKING WITH DATA IN R,</li>
<li>STINGS AND DATES IN R</li>
<li>INTRODUCTION TO BUSINESS ANALYTICS,</li>
<li>INTRODUCTION TO R PROGRAMMING,</li>
<li>DATA STRUCTURES, DATA VISUALIZATION</li>
<li>STATISTICS FOR DATA SCIENCE I,</li>
<li>STATISTICS FOR DATA SCIENCE II ,</li>
<li>REGRESSION ANALYSIS,</li>
<li>CLASSIFICATION, CLUSTERING</li>
<li>ASSOCIATION</li>
<b>Python with Data Science</b>
<li>PYTHON BASICS,</li>
<li>PYTHON DATA STRUCTURES,</li>
<li>PYTHON PROGRAMMING FUNDAMENTALS ,</li>
<li>WORKING WITH DATA IN PYTHON</li>
<li>WORKING WITH NUMPY ARRAYS,</li>
<li>DATA SCIENCE OVERVIEW,</li>
<li>DATA ANALYTICS OVERVIEW,</li>
<li>STATISTICAL ANALYSIS AND BUSINESS</li>
<li>APPLICATIONS</li>
<li>PYTHON ENVIRONMENT SETUP AND</li>
<li>ESSENTIALS,</li>
<li>MATHEMATICAL COMPUTING WITH PYTHON</li>
<li>(NUMPY) ,</li>
<li>SCIENTIFIC COMPUTING WITH PYTHON (SCIPY),</li>
<li>DATA MANIPULATION WITH PANDAS,</li>
<li>MACHINE LEARNING WITH SCIKIT–LEARN,</li>
<li>NATURAL LANGUAGE PROCESSING WITH</li>
<li>SCIKIT LEARN,</li>
<li>DATA VISUALIZATION IN PYTHON USING</li>
<li>MATPLOTLIB,</li>
<li>WEB SCRAPING WITH BEAUTIFUL SOUP ,</li>
<li>PYTHON INTEGRATION WITH HADOOP</li>
<li>MAPREDUCE AND SPAR</li>
<b>Machine Learning</b>
<li>INTRODUCTION TO ARTIFICIAL INTELLIGENCE</li>
<li>AND MACHINE LEARNING,</li>
<li>DATA WRANGLING AND MANIPULATION,</li>
<li>SUPERVISED LEARNING</li>
<li>FEATURE ENGINEERING,</li>
<li>SUPERVISED LEARNING</li>
<li>CLASSIFICATION, UNSUPERVISED LEARNING,</li>
<li>TIME SERIES MODELLING</li>
<li>ENSEMBLE LEARNING,</li>
<li>RECOMMENDER SYSTEMS,</li>
<li>TEXT MINING</li>
<b>TABLEAU</b>
<li>GETTING STARTED WITH TABLEAU,</li>
<li>WORKING WITH TABLEAU,</li>
<li>DEEP DIVING WITH DATA AND CONNECTIONS,</li>
<li>CREATING CHARTS</li>
<li>ADDING CALCULATIONS TO YOUR WORKBOOK,</li>
<li>MAPPING DATA IN TABLEAU,</li>
<li>DASHBOARDS AND STORIES,</li>
<li>VISUALIZATIONS FOR AN AUDIENCE</li>  
              
                </div>
              </div>
            </div>
            {/* <div className="tp-form__btn" style={{paddingBottom: 15, textAlign: 'center', paddingTop: 15}}>
              <a onclick="show();" className="tp-btn" style={{cursor: 'pointer'}}>
                <span>Book A Demo <i className="fa-regular fa-arrow-right" /> </span>
              </a>
            </div> */}
          </div>
          {/* <div className="tp-form__btn" style={{paddingBottom: 15, textAlign: 'center', paddingTop: 15}}>
            <a onclick="show();" className="tp-btn" style={{cursor: 'pointer'}}>
              <span>Book A Demo <i className="fa-regular fa-arrow-right" /> </span>
            </a>
          </div> */}

<button type="button" className="btn btn-primary mt-3" style={{marginLeft:'45%'}} data-toggle="modal" data-target="#exampleModalCenter">
    Book A Demo <i className="fa-regular fa-arrow-right" />
  </button>
  {/* Modal */}
  <div className="modal fade" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
        <p style={{color: '#000f2f', fontSize: 20, textAlign: 'center', textDecoration: 'underline', fontWeight: 700}}>Courses Enquiry</p>
     
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          
        </div>
        <div className="heading_s1 mb-3" style={{textAlign: 'center'}}>
                      <h6>Please feel the below form, we will call you very shortly</h6>
                    </div>
        <div className="modal-body">
        <form action="mail.php" method="POST" className="pt-md-2">
                      <div className="row">
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Your Name *" id="nameEnquiry" className="form-control alpha-only" name="fname" type="text" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Mobile No. *" id="phoneEnquiry" className="form-control number-only" name="mobile" type="text" maxLength={10} oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Email ID" id="emailEnquiry" className="form-control" name="email" type="text" />
                        </div>
                        <div className="form-group col-sm-12" style={{paddingTop: 10, paddingBottom: 15}}>
                          <input required="required" placeholder="Enter Course Name" id="course" className="form-control" name="course" type="text" />
                          {/*<input t placeholder="Enter course" id="message" class="form-control" name="Message" rows="4"></textarea>*/}
                        </div>
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                          {/*<input type="submit" name="submit" value="Send Details" class="tp-btn"  id="submitEnquiry" />*/}
                          <button className="tp-btn" onclick="return validationEnquiry();" style={{cursor: 'pointer'}}>
                            <span>Submit <i className="fa-regular fa-arrow-right" /> </span>
                          </button> 
                        </div>
                        <div className="col-sm-12">
                          <div id="alert-msg" className="alert-msg text-center" />
                        </div>
                      </div>
                    </form>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>

        </div>
       
            
      </div>
    </div>
  </div>
</main>

      <Footer/>
    </div>
  )
}
